import { kleur } from '../theme/tokens';
import React, { useState } from 'react';

function Login({ onLogin, apiUrl }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${apiUrl}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (response.ok) {
        onLogin(data.user, data.token);
      } else {
        setError(data.detail || 'Inloggen mislukt');
      }
    } catch (err) {
      setError('Kan geen verbinding maken met de server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <img 
            src="/socrates_met_lamp.png" 
            alt="Socrates" 
            style={styles.image}
          />
          <p style={styles.subtitle}>Leren argumenteren</p>
        </div>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Gebruikersnaam"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={styles.input}
            onFocus={(e) => e.target.style.border = '2px solid black'}
            onBlur={(e) => e.target.style.border = username ? '2px solid black' : `2px solid ${kleur.lijn}`}
            required
          />
          <input
            type="password"
            placeholder="Wachtwoord"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            onFocus={(e) => e.target.style.border = '2px solid black'}
            onBlur={(e) => e.target.style.border = password ? '2px solid black' : `2px solid ${kleur.lijn}`}
            required
          />          
          {error && <p style={styles.error}>{error}</p>}
          
          <button 
            type="submit" 
            style={styles.button}
            disabled={loading}
          >
            {loading ? 'Bezig...' : 'Inloggen'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'white',
    padding: '20px',
  },
card: {
    background: 'white',
    padding: '40px',
    width: '100%',
    maxWidth: '450px',
  },
  header: {
    textAlign: 'center',
    marginBottom: '32px',
  },
  image: {
    width: '100%',
    maxWidth: '350px',
    height: 'auto',
    marginBottom: '16px',
    borderRadius: '8px',
  },
  subtitle: {
    color: kleur.stil,
    fontSize: '14px',
  },
input: {
    width: '100%',
    padding: '14px',
    border: `2px solid ${kleur.lijn}`,
    borderRadius: '8px',
    fontSize: '16px',
    marginBottom: '16px',
    outline: 'none',
    transition: 'border-color 0.2s',
    backgroundColor: 'white',
    WebkitBoxShadow: '0 0 0 1000px white inset',
    WebkitTextFillColor: 'black',
  },  
  button: {
    width: '100%',
    padding: '14px',
    background: kleur.accent,
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'background 0.2s',
  },
  error: {
    color: kleur.rood,
    marginBottom: '16px',
    textAlign: 'center',
  },
};

export default Login;
